var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_tree_FILL0_wght400_GRAD0_opsz24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.254,
    height: 11.929,
    viewBox: "0 0 13.254 11.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account_tree_FILL0_wght400_GRAD0_opsz24-2",
    "data-name": "account_tree_FILL0_wght400_GRAD0_opsz24",
    d: "M88.615-828.071v-1.988H85.964v-6.627H84.639v1.988H80V-840h4.639v1.988h3.976V-840h4.639v5.3H88.615v-1.988H87.29v5.3h1.325v-1.988h4.639v5.3Zm-7.29-10.6v0Zm8.615,6.627v0Zm0-6.627v0Zm0,2.651h1.988v-2.651H89.941Zm0,6.627h1.988v-2.651H89.941Zm-8.615-6.627h1.988v-2.651H81.325Z",
    transform: "translate(-80 840)",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.9ed907de0f415d893cce639f8439e397.svg";
export { ForwardRef as ReactComponent };